import React, { memo } from 'react';
import { FormControl, FormLabel } from '@mui/material';
import { FilterInnerContainer, MetricReportsFilterContainer } from './styles';
import TimeZone from './components/TimeZone';
import DateTimeInput from './components/DateTimeInput';
import TimeRange from './components/TimeRange';
import Metrics from './components/Metrics';
import { getOffsetByFormatType, TimeFormatType } from '../../../../../../common/components/TimeFormat/TimeFormat';
import Toggle from '../../../../../../common/components/Toggle/Toggle';

function FiltersToolbar(props) {
  const { isRealTime = false, showMetrics, filters, onChange, onSubmit, demo, isConsolidatedView, setIsConsolidatedView } = props;

  const handleChange = async (e) => {
    await onChange(e);

    onSubmit(e, filters);
  };

  const { timeRange, metrics = [''], from, to, utc } = filters;

  const utcAddition = utc === getOffsetByFormatType(TimeFormatType.UTC) ? ' (UTC)' : '';

  return (
    <MetricReportsFilterContainer>
      <FilterInnerContainer>
        {isRealTime ? (
          <>
            <TimeRange value={timeRange} onChange={handleChange} isRealTime={isRealTime} />
            <Metrics
              show={showMetrics}
              demo={demo}
              value={metrics}
              onChange={handleChange}
              onClose={onSubmit}
              className="filter filter-metric"
            />
          </>
        ) : (
          <>
            <DateTimeInput name="from" label={`From${utcAddition}`} offset={utc} date={from} onChange={handleChange} disabled={demo} />
            <DateTimeInput name="to" label={`To${utcAddition}`} offset={utc} date={to} onChange={handleChange} disabled={demo} />
            <Metrics
              show={showMetrics}
              demo={demo}
              value={metrics}
              onChange={handleChange}
              onClose={onSubmit}
              className="filter filter-metric"
            />
          </>
        )}
        <FormControl>
          <FormLabel style={{ fontSize: '14px' }}>Consolidated View:</FormLabel>
          <Toggle toggled={isConsolidatedView} onToggle={setIsConsolidatedView} />
        </FormControl>
      </FilterInnerContainer>

      <TimeZone value={utc} onChange={onChange} />
    </MetricReportsFilterContainer>
  );
}

export default memo(FiltersToolbar);
